import React from 'react';
import { BlockProps } from '../index.types';
import PageLifeSection, {
    PageLifeSectionProps,
} from 'components/page-life-section/page-life-section';
import { decode, decodePossible } from 'lib/decode';

type PageImageTextSectionPropsType = BlockProps & PageLifeSectionProps;

export default function PageImageTextSection({ block, ...props }: PageImageTextSectionPropsType) {
    return (
        <PageLifeSection
            caption={decodePossible(props.caption)}
            title={decode(props.title)}
            text={decode(props.text)}
            ctaLink={decodePossible(props.ctaLink)}
            ctaText={decodePossible(props.ctaText)}
            ctaLinkTwo={decodePossible(props.ctaLinkTwo)}
            ctaTextTwo={decodePossible(props.ctaTextTwo)}
            extraText={decodePossible(props.extraText)}
            imageSrc={props.imageSrc}
            imageAspectRatio={props.imageAspectRatio}
            imagePosition="right"
            brand={props.brand || 'bumble'}
        />
    );
}
